import * as React from 'react'

export interface ISwitcherProps {
  state: boolean
  onClick: () => void
}

const Toggle = (props: ISwitcherProps) => {
  const classNameWrap = props.state ? 'switch--slider switch--slider-on' : 'switch--slider switch--slider-off'
  return (
    <div className='switch' onClick={props.onClick}>
      <div className={classNameWrap} />
    </div>
  )
}

export default Toggle



// WEBPACK FOOTER //
// ./src/components/ui/Toggle.tsx